// Generated by Claude Code
import { createFileRoute } from '@tanstack/react-router'
import { EmployeesAnalyticsPage } from '#components/domain/operations/analytics/employees/employees-analytics-page.tsx'

export const Route = createFileRoute('/_app/$companyId/analytics/employees')({
  component: EmployeesAnalyticsPage,
  staticData: { title: 'Analysis', appShell: true },
})
